import { render, staticRenderFns } from "./getCouponRecord.vue?vue&type=template&id=0185653c&scoped=true"
import script from "./getCouponRecord.vue?vue&type=script&lang=js"
export * from "./getCouponRecord.vue?vue&type=script&lang=js"
import style0 from "./getCouponRecord.vue?vue&type=style&index=0&id=0185653c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0185653c",
  null
  
)

export default component.exports